const UsecaseUsagePermissions = {
  VIEW_USECASE_USAGE_TAB: 'use_case_usage_read',
};

export default UsecaseUsagePermissions;
